/* eslint-disable */
import { CheckCircle2 } from 'lucide-react'
import placeholder from '../../assets/placeholder.svg'
import { Button } from '../../Components/ui/button'
import EmptyState from '../../Components/Common/EmptyState'
import { toCurrency } from '../../utils/CurrencyUtil'
import tick from '../../assets/PaymentGateway/Frame 354190.svg'
import env from '../../env/env'
import { AccountBalance } from '@mui/icons-material'
import { useState } from 'react'

const BankAccountItem = ({ bank, isSelected, onSelect, tickIcon, bankLogosUrl }) => {

    const [iconSrc, setIconSrc] = useState(() => {
        const branch = bank.ifscCode?.match(/^[A-Za-z]{4}/)?.[0]?.toLowerCase()
        return branch ? `${bankLogosUrl}/${branch}/symbol.svg` : null
    })
    return (
        <div
            onClick={(e) => { e.stopPropagation(); onSelect(bank.accountNo) }}
            className={`w-full p-4 flex items-center gap-4 rounded-[16px] cursor-pointer transition-all duration-200 ease-in-out border ${isSelected ? 'border-primary-500 bg-primary-50' : 'border-transparent hover:bg-[#ecf0f4]'}`}
        >
            <div className='flex-shrink-0'>
                {iconSrc ? (
                    <img
                        src={iconSrc}
                        alt='bank logo'
                        onError={() => setIconSrc(null)}
                        height={24}
                        width={24}
                    />
                ) : (
                    <AccountBalance className='text-primary-200' />
                )}
            </div>
            <div className='flex flex-col'>
                <span className='text-[#2f3c5a] font-semibold'>{bank.accountHolderName}</span>
                <span className='text-[#2f3c5a] text-xs'>
                    {bank.bankName} A/c ending in <strong> {bank.accountNo?.slice(-4)}</strong>
                </span>
            </div>

            <div className='ml-auto flex-shrink-0'>
                <div className='flex h-6 w-6 items-center justify-center'>
                    {isSelected ? (
                        <img src={tickIcon} alt='' />
                    ) : (
                        <span
                            className='box-border block h-5 w-5 shrink-0 rounded-full border-2 border-[#c5cedd] bg-transparent'
                            aria-hidden
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const MANDATE_DESCRIPTION_TEXT =
    'An ICCL Mandate is a secure payment authorization that allows the Indian Clearing Corporation Limited (ICCL), a subsidiary of the Bombay Stock Exchange (BSE), to automatically debit funds from your bank account for investments such as Mutual Funds and SIPs. Please note that the mandate is registered in favor of ICCL and not Fabits. At no point does Fabits receive or hold your funds.'

const MandateDescription = () => (
    <>
        An ICCL Mandate is a secure payment authorization that allows the Indian Clearing Corporation Limited (ICCL), a subsidiary of the Bombay Stock Exchange (BSE), to automatically debit funds from your bank account for investments such as Mutual Funds and SIPs.
        <br />
        <br />
        Please note that the mandate is registered in favor of ICCL and not Fabits. At no point does Fabits receive or hold your funds.
    </>
)

const MANDATE_DESCRIPTION_PREVIEW_LENGTH = 140

const Mandates = ({ mandateResult, mandateRegistration, mandateLoading, mandates, bankAccountsList, selectedBank, setSelectedBank }) => {
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false)

    return (
        <>
            {mandateResult && (
                <div className='mb-4'>
                    <h1 className='flex justify-between items-center mt-4'>
                        <span className='font-DMSans font-semibold text-lg md:text-xl text-black-500'>
                            Your Mandates
                        </span>
                    </h1>
                    <p className='font-DMSans md:text-lg text-sm font-normal text-black-400'>
                        Complete mandate to start your investment journey.
                    </p>
                </div>
            )}

            {mandateResult ? (
                <div
                    className={`border border-[#D3DBEC] py-4 px-3 md:p-5 rounded-[6px] overflow-hidden transition-all duration-300 ease-in-out`}
                >
                    <div className='flex justify-between'>
                        <div className='flex gap-3 items-start'>
                            <img src={placeholder} className='h-6 w-6 md:h-8 md:w-8' alt='plan' />
                            <div className='font-DMSans md:text-lg text-base font-medium'>Mandate Amount</div>
                        </div>
                        <div className='font-DMSans font-medium flex items-center text-primary-600'>
                            <span className='font-DMSans text-xl md:text-2xl font-extrabold mr-2 flex items-end'>
                                ₹
                            </span>
                            <span className='font-OrelegaOne text-xl md:text-2xl tracking-[4%]'>
                                {toCurrency(mandateResult?.amount)}
                            </span>
                        </div>
                    </div>
                    <p className='text-muted-foreground text-sm mt-4'>
                        {isDescriptionExpanded ? (
                            <MandateDescription />
                        ) : (
                            `${MANDATE_DESCRIPTION_TEXT.slice(0, MANDATE_DESCRIPTION_PREVIEW_LENGTH).trimEnd()}… `
                        )}
                        <br />
                        <button
                            type='button'
                            onClick={() => setIsDescriptionExpanded((prev) => !prev)}
                            className='text-primary-600 font-medium inline hover:text-primary-700 mt-2'
                        >
                            {isDescriptionExpanded ? 'View less' : 'View more'}
                        </button>
                    </p>
                </div>
            ) : (
                <EmptyState
                    icon={<CheckCircle2 className='w-16 h-16 text-success' strokeWidth={1.5} />}
                    title='All Set!'
                    description='You have no pending mandates. All your payment authorizations are active and working.'
                />
            )}

            {mandateResult && (
                <div
                    className={`fixed bottom-0 left-0 right-0 p-4 z-10 lg:max-w-[1128px] mx-auto bg-white mt-2`}
                    style={{ boxShadow: '0px 4px 21.6px 0px #00000040', borderRadius: '24px 24px 0px 0px' }}
                >
                    {bankAccountsList.length > 1 && <p className='font-dm-sans px-2 text-sm font-medium leading-[18px] text-left text-[#2d2d2d] mb-2'>
                        Select a bank account to continue
                    </p>}
                    {bankAccountsList.map((bank) => (
                        <BankAccountItem
                            key={bank.accountNo}
                            bank={bank}
                            isSelected={selectedBank === bank.accountNo}
                            onSelect={setSelectedBank}
                            tickIcon={tick}
                            bankLogosUrl={env.BANK_LOGOS}
                        />
                    ))}

                    <Button
                        disabled={!selectedBank}
                        className={`w-full rounded-xl bg-primary-500 disabled:bg-primary-300 mt-4 mb-safe `}
                        onClick={() => mandateRegistration(mandates?.data)}
                        loading={mandateLoading}
                    >
                        Approve Mandate
                    </Button>
                </div>
            )}
        </>
    )
}

export default Mandates
